/**
 * ADA Contact Form Inline Validation (SXMS-134, Issue 13b)
 * Shows inline error messages on invalid required fields.
 * Messages include the field name per WCAG 3.3.1.
 */
(function () {
  var form = document.getElementById('ContactForm');
  if (!form) return;

  var fields = [
    { id: 'ContactFormName', errorId: 'ContactFormName-error', label: 'Name' },
    { id: 'ContactFormEmail', errorId: 'ContactFormEmail-error', label: 'Email' },
    { id: 'ContactFormMessage', errorId: 'ContactFormMessage-error', label: 'Message' }
  ];

  function getErrorMessage(input, label) {
    if (input.validity.valueMissing) {
      return 'Error: Please enter a valid ' + label + '.';
    }
    if (input.validity.typeMismatch) {
      return 'Error: Please enter a valid ' + label + ' address.';
    }
    return 'Error: Please enter a valid ' + label + '.';
  }

  fields.forEach(function (field) {
    var input = document.getElementById(field.id);
    var error = document.getElementById(field.errorId);
    if (!input || !error) return;

    input.addEventListener('invalid', function (e) {
      e.preventDefault();
      error.textContent = getErrorMessage(input, field.label);
      error.style.display = 'block';
      input.setAttribute('aria-invalid', 'true');
    });

    input.addEventListener('input', function () {
      if (input.validity.valid) {
        error.textContent = '';
        error.style.display = 'none';
        input.removeAttribute('aria-invalid');
      }
    });
  });
})();
